import React from "react";
import { createRoot } from "react-dom/client";
import StylesProvider from "@mui/styles/StylesProvider";
import { initSentry } from "./sentry";

initSentry();

import App from "./App";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <StylesProvider injectFirst>
    <App />
  </StylesProvider>
);
